import { z } from "zod";

const file = {
    uri: z.string().min(1, "File URI is required"),
    name: z.string().min(1, "File name is required"),
    type: z.string().min(1, "File type is required"),
    size: z.number().positive("File size must be greater than 0"),
};
export const rnFileSchema = z.object({
    ...file,
}, { error: "File is required" });

export const VehicleInsuranceFileSchema = z.object({
    ...file,
}, { error: "Vehicle insurance is required" });

export const VehiclePhotoFileSchema = z.object({
    ...file,
}, { error: "Vehicle photo is required" });

export const MAX_UPLOAD_SIZE = 5 * 1024 * 1024; // 5MB
export const ACCEPTED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "application/pdf"
];

export type RNFile = z.infer<typeof rnFileSchema>;

export const fileSizeValidator = (file: unknown) => {
  if (typeof file === "object" && file !== null && "size" in file) {
    return (file as { size: number }).size <= MAX_UPLOAD_SIZE;
  }

  return true;
};

export const fileTypeValidator = (file: unknown) => {
  if (typeof file === "object" && file !== null && "type" in file) {
    const type = (file as { type: string }).type;
    return !type || ACCEPTED_IMAGE_TYPES.includes(type);
  }

  return true;
};
